import AboutHeader from "./AboutHeader";
import WorkExperiences from "./WorkExperiences";
import Skills from "./Skills";

const About = () => {
  return (
    <>
      <AboutHeader />
      <WorkExperiences />
      <Skills />
    </>
  );
};

export default About;
